<template>
<div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
        <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
        <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card class="box">
        <v-toolbar class="toolbar no-display" flat dense>
            <v-toolbar-title>
                <strong> Percentage Wise Fee Details Report </strong>
            </v-toolbar-title>
        </v-toolbar>
        <v-row dense justify="center" class="no-display">
            <v-col sm="3" md="3" cols="12">
                <v-icon color="error">*</v-icon>
                <v-autocomplete rounded dense required v-model="current_academic_year" :items="academic_year_list" item-text="ay" return-object label="Academic Year" outlined persistent-hint hint="Please Select Academic Year" @change="clearData()"></v-autocomplete>
            </v-col>
            <v-col sm="3" md="3" cols="12">
                <v-icon color="error">*</v-icon>
                <v-autocomplete @change="clearData()" rounded dense required v-model="sections" multiple :items="section_list" item-text="name" item-value="id" label="Section" outlined persistent-hint hint="Please Select Section"></v-autocomplete>
            </v-col>

            <!-- Standard Dropdown (Filtered) -->
            <v-col sm="3" md="3" cols="12">
                <v-icon color="error">*</v-icon>
                <v-autocomplete @change="clearData()" rounded dense required v-model="std" :items="filteredStandardList" item-text="standard" item-value="id" label="Standard" outlined persistent-hint hint="Please Select Standard"></v-autocomplete>
            </v-col>
            <v-col sm="3" md="3" cols="12">
                <v-icon color="error">*</v-icon>
                <v-autocomplete @change="clearData()" color="#0F2027" dense rounded required v-model="status" :items="status_list" item-text="name" item-value="id" label="Status" outlined persistent-hint hint="Select Status" />
            </v-col>
            <v-col sm="3" md="3" cols="12">
                <v-btn rounded class="button mt-6" @click="clearData();getAllReport()" :loading="loader">Fetch</v-btn>
            </v-col>
        </v-row>
        <v-row v-if="std_data!=''" dense>
            <v-col cols="12" sm="2" md="2">
                <v-btn class="ma-2 no-display" rounded color="success" outlined @click="fnExcelReport('my-table-id', 'feedetailedreport')" :loading="loader">
                    <v-icon color="success">mdi-export</v-icon>Export
                </v-btn>
            </v-col>
            <v-col cols="12" sm="2" md="2">
                <v-btn class="ma-2 no-display" tile outlined color="warning" @click="showLogo()">
                    Hide /Show Logo
                </v-btn>
            </v-col>
            <v-col cols="12" sm="2" md="2">
                <v-btn class="ma-2 no-display" tile outlined color="warning" @click="printReport()">
                    <v-icon left>mdi-printer</v-icon> Print <v-icon right></v-icon>
                </v-btn>
            </v-col>
        </v-row>
        <div id="my-table-id">
            <!-- header code -->
            <v-simple-table></v-simple-table>
            <div v-if="org_basic_data!='' && std_data!=''">
                <v-row dense justify="center">
                    <v-col cols="12" sm="4" md="2" v-if="org_basic_data.trust_logo && show_logo" align="center">
                        <img :src="org_basic_data.trust_logo" alt="logo" class="trust-logo" />
                    </v-col>
                    <v-col cols="12" sm="4" md="8">
                        <center>
                            <h2>
                                <strong>{{ org_basic_data.trust_name }}</strong>
                            </h2>
                            <h3>
                                <strong>{{ org_basic_data.school_name }} </strong>
                            </h3>
                            <span>{{ org_basic_data.address }}</span> <br />
                            <span>Phone :{{ org_basic_data.phone }} </span> <br />
                            <span>Email :{{ org_basic_data.email }} </span> <br />
                            <span>Website :{{ org_basic_data.website }} </span>
                            <br />
                        </center>
                    </v-col>
                    <v-col cols="12" sm="4" md="2" v-if="org_basic_data.school_logo && show_logo">
                        <img :src="org_basic_data.school_logo" alt="logo" class="schl-logo" />
                    </v-col>
                </v-row>
            </div>
            <div v-if="std_data!=''">
                <center>
                    <b>
                        <span>Percentage Wise Fee Details Report </span>
                    </b>
                </center>
            </div>
            <v-simple-table v-if="std_data!=''" dense class="elevation-1 mytable2">
                <!-- <thead> -->
                <tr class="toolbar">
                    <th class="">
                        <center>Sr. No.</center>
                    </th>
                    <th class="">
                        <center>Standard</center>
                    </th>
                    <th class="">
                        <center>No. of Student</center>
                    </th>
                    <th class="">
                        <center>Applicable Fee</center>
                    </th>
                    <th class="" colspan="3">
                        <center>No. oF Students Fees Paid</center>
                    </th>
                    <th class="">
                        <center>Fees Paid Student % Ratio</center>
                    </th>
                    <th class="" colspan="4">
                        <center>Fees Received</center>
                    </th>
                    <th class="">
                        <center>Fees Collection Ratio % (Applicable fees : Total fees received)</center>
                    </th>
                    <th class="">
                        <center>No. of Student Fees Not Paid</center>
                    </th>
                    <th class="">
                        <center>% Ratio (Total students : Not paid students)</center>
                    </th>
                    <th colspan="3" class="">
                        <center>Fees Due</center>
                    </th>
                </tr>
                <!-- </thead> -->
                <tbody>
                    <tr>
                        <th class=""></th>
                        <th class=""></th>
                        <th class=""></th>
                        <th class=""></th>
                        <th class="">Full</th>
                        <th class="">Partial</th>
                        <th class="">Total</th>
                        <th class=""></th>
                        <th class="">Full</th>
                        <th class="">Partial</th>
                        <th class="">Excess</th>
                        <th class="">Total</th>
                        <th class=""></th>
                        <th class=""></th>
                        <th class=""></th>
                        <th class="">Partial Paid</th>
                        <th class="">Not Paid</th>
                        <th class="">Total</th>
                    </tr>
                    <tr v-for="s,index in std_data" :key="index">
                        <td>{{ index+1 }}</td>
                        <td>{{ s.standard }}</td>
                        <td>{{ s.no_of_student }}</td>
                        <td>{{ s.regular_applicable_fees }}</td>
                        <td>{{ s.full_paid }}</td>
                        <td>{{ s.partial_paid }}</td>
                        <td>{{ s.total_paid }}</td>
                        <td>{{ s.fees_paid_percent }}</td>
                        <td>{{ s.full_fees_received }}</td>
                        <td>{{ s.partial_fees_received }}</td>
                        <td>{{ s.excess_amount }}</td>
                        <td>{{ s.total_received_fees }}</td>
                        <td>{{ s.fees_received_percent }}</td>
                        <td>{{ s.not_paid }}</td>
                        <td>{{ s.fees_not_paid_percent }}</td>
                        <td>{{ s.partial_paid_fees_due }}</td>
                        <td>{{ s.not_paid_fees_due }}</td>
                        <td>{{ s.total_due_fees }}</td>
                    </tr>
                    <tr>
                        <td></td>
                        <td></td>
                        <td>{{ total_no_of_student }}</td>
                        <td>{{ total_applicable_fees }}</td>
                        <td>{{ total_full_paid }}</td>
                        <td>{{ total_partial_paid }}</td>
                        <td>{{ total_paid_student }}</td>
                        <td>{{ total_fees_paid_percent }}</td>
                        <td>{{ total_full_fees_received }}</td>
                        <td>{{ total_partial_fees_received }}</td>
                        <td>{{ total_excess_fees }}</td>
                        <td>{{ total_student_received_fees }}</td>
                        <td>{{ total_fees_received_percent }}</td>
                        <td>{{ total_not_paid }}</td>
                        <td>{{ total_fees_not_paid_percent }}</td>
                        <td>{{ total_partial_paid_fees_due }}</td>
                        <td>{{ total_not_paid_fees_due }}</td>
                        <td>{{ total_student_due_fees }}</td>
                    </tr>
                </tbody>
            </v-simple-table>
        </div>
    </v-card>
</div>
</template>

<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
    data() {
        return {
            section_list: [],
            sections: [],
            loader: false,
            color: "",
            snackbar: false,
            search: "",
            snackbar_msg: null,
            current_academic_year: null,
            std: null,
            header: null,
            academic_year_list: null,
            standard_list: null,
            show: false,
            std_data: [],
            total_no_of_student: null,
            total_full_paid: null,
            total_partial_paid: null,
            total_paid_student: null,
            total_applicable_fees: null,
            total_fees_paid_percent: null,
            total_full_fees_received: null,
            total_student_received_fees: null,
            total_partial_fees_received: null,
            total_not_paid: null,
            total_fees_not_paid_percent: null,
            total_fees_received_percent: null,
            total_excess_fees: null,
            total_partial_paid_fees_due: null,
            total_student_due_fees: null,
            total_not_paid_fees_due: null,
            org_basic_data: [],
            show_logo: true,
            status_list: [{
                    name: "Active",
                    id: "0"
                },
                {
                    name: "Temporary Inactive",
                    id: "1"
                },
                {
                    name: "Permanent Inactive",
                    id: "2"
                },
            ],
            status: null,
        };
    },
    computed: {},
    methods: {
        showLogo() {
            if (this.show_logo) {
                this.show_logo = false;
            } else {
                this.show_logo = true;
            }
        },
        fnExcelReport(id, name) {
            var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
            tab_text = tab_text + "<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
            tab_text = tab_text + "<x:Name>Test Sheet</x:Name>";
            tab_text = tab_text + "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
            tab_text = tab_text + "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
            tab_text = tab_text + "<table border='1px'>";
            var exportTable = $("#" + id).clone();
            exportTable.find("input").each(function (index, elem) {
                $(elem).remove();
            });
            tab_text = tab_text + exportTable.html();
            tab_text = tab_text + "</table></body></html>";
            var fileName = name + "_" + parseInt(Math.random() * 10000000000) + ".xls";

            //Save the file
            // var blob = new Blob([tab_text], {
            //     type: "application/vnd.ms-excel;charset=utf-8",
            // });
            // window.saveAs(blob, fileName);
            const blob = new Blob([tab_text], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            });
            const filename = name + ".xls";

            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                // For IE
                window.navigator.msSaveOrOpenBlob(blob, filename);
            } else {
                // For modern browsers
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = url;
                a.download = filename;
                a.click();
                window.URL.revokeObjectURL(url);
            }
        },
        showLogo() {
            if (this.show_logo) {
                this.show_logo = false;
            } else {
                this.show_logo = true;
            }
        },
        printReport() {
            this.$store.state.drawer = false;
            let that = this;
            window.onafterprint = function () {
                that.$store.state.drawer = true;
            };
            setTimeout(function () {
                window.print();
            }, 100);
        },
        ExportToExcel() {
            var htmltable = document.getElementById("my-table-id");
            var html = htmltable.outerHTML;
            window.open("data:application/vnd.ms-excel," + encodeURIComponent(html));
        },

        clearData() {
            this.std_data = [];
            this.total_no_of_student = null;
            this.total_full_paid = null;
            this.total_partial_paid = null;
            this.total_paid_student = null;
            this.total_not_paid = null;
            this.total_fees_paid_percent = null;
            this.total_applicable_fees = null;
            this.total_fees_not_paid_percent = null;
            this.total_full_fees_received = null;
            this.total_partial_fees_received = null;
            this.total_fees_received_percent = null;
            this.total_excess_fees = null;
            this.total_student_received_fees = null;
            this.total_partial_paid_fees_due = null;
            this.total_student_due_fees = null;
            this.total_not_paid_fees_due = null;
            this.org_basic_data = null;
        },
        onerror(error) {
            let msg = "";
            if (error.response) {
                msg = "Something went wrong.";
            } else if (error.request) {
                msg = "Please Select Proper Data.";
            } else {
                msg = "Un-expected error.";
            }
            this.showSnackbar("error", msg);
        },
        async getAllReport() {
            this.loader = true;
            this.search = "";
            this.clearData()
            const data = {
                ay: this.current_academic_year.id,
                std: this.std,
                status: this.status,
                sections:this.sections
            };
            try {
                const res = await axios.post("/AccountingAndFeesReports/percentageFeesReport", data);
                if (res.data.flag == "YES") {
                    this.std_data = res.data.std_data;
                    this.total_no_of_student = res.data.total_no_of_student;
                    this.total_full_paid = res.data.total_full_paid;
                    this.total_partial_paid = res.data.total_partial_paid;
                    this.total_paid_student = res.data.total_paid_student;
                    this.total_not_paid = res.data.total_not_paid;
                    this.total_fees_paid_percent = res.data.total_fees_paid_percent;
                    this.total_applicable_fees = res.data.total_applicable_fees;
                    this.total_fees_not_paid_percent = res.data.total_fees_not_paid_percent;
                    this.total_full_fees_received = res.data.total_full_fees_received;
                    this.total_partial_fees_received = res.data.total_partial_fees_received;
                    this.total_fees_received_percent = res.data.total_fees_received_percent;
                    this.total_excess_fees = res.data.total_excess_fees;
                    this.total_student_received_fees = res.data.total_student_received_fees;
                    this.total_partial_paid_fees_due = res.data.total_partial_paid_fees_due;
                    this.total_student_due_fees = res.data.total_student_due_fees;
                    this.total_not_paid_fees_due = res.data.total_not_paid_fees_due;
                    this.org_basic_data = res.data.org_basic_data;
                } else if (res.data.flag == "No") {
                    this.showSnackbar("red", res.data.fmsg);
                } else {
                    this.showSnackbar("red", res.data.snackbar);
                    sessionStorage.setItem("error-trace", res.data.error_trace);
                }
                this.loader = false;
            } catch (err) {
                console.log("err", err);
                this.onerror(err);
                this.loader = false;
            } finally {
                this.loader = false;
            }
        },
        onerror(error) {
            let msg = "";
            if (error.response) {
                msg = "Something went wrong.";
            } else if (error.request) {
                msg = "Please try again.";
            } else {
                msg = "Un-expected error.";
            }
            this.showSnackbar("error", msg);
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
        onload() {
            axios
                .post("/InstallmentStructureDetails/getAllData")
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.academic_year_list = res.data.ay_data;
                        this.current_academic_year = res.data.cay;
                        this.standard_list = res.data.standard_list;
                        this.section_list = res.data.section_list_all;
                    }
                })
                .catch((error) => {
                    window.console.log(error);
                })
                .finally(() => {
                    //close loader
                    this.get_ay_std_ft_loader = false;
                });
        },
    },
    mounted() {
        this.onload();
    },
    computed: {
        filteredStandardList() {
      let filteredStandards;

      if (!this.sections.length || this.sections.includes(null)) {
        // If no section is selected or "All" is selected, show all standards
        filteredStandards = this.standard_list;
      } else {
        // Filter standards based on selected sections
        filteredStandards = this.standard_list.filter(std =>
          this.sections.includes(std.sectionID)
        );
      }

      // Ensure "All" option is always present at the top
      return [{ standard: "All", id: null, sectionID: null }, ...filteredStandards];
    }
    },
};
</script>

<style scoped>
/* .scroll {
  overflow-x: scroll;
} */
.text-color {
    font-weight: bold;
    color: red;
    font-size: small;
}

tr,
td,
th {
    border: 1px solid #ccc;
    text-align: center;
    font-size: small;
}

tr,
tbody {
    border-bottom: 1px solid #ccc;
    border: 1px solid #ccc;
    font-size: small;
}

td {
    margin: 0.3rem !important;
    padding: 0.4rem !important;
    font-size: small;
}

@media (min-width: 320px) {

    td,
    th {
        display: table-cell !important;
        font-size: small;
    }

    td+td,
    th+th {
        width: auto;
        font-size: small;
    }
}

v-simple-table {
    white-space: nowrap !important;
    text-align: center;
    font-size: small;
}

.dt-button {
    font-size: small;
    font-weight: bold;
}

.dt-button.buttons-print::before {
    content: "\F42A";
    margin-right: 8px;
    margin-top: 8px;
    font-size: small;
}

.dt-button.buttons-excel::before {
    content: "\F21B";
    margin-right: 8px;
    margin-top: 8px;
    font-size: small;
}

.dt-button.buttons-csv::before {
    content: "\FEC2";
    margin-right: 8px;
    margin-top: 8px;
    font-size: small;
}

button.dt-button:hover:not(.disabled),
div.dt-button:hover:not(.disabled),
a.dt-button:hover:not(.disabled) {
    border-color: #ff9800;
    color: #ff9800;
}

.dataTables_wrapper .dataTables_filter input[type="search"] {
    border-radius: 2px;
    border: 1px solid #cdcdcd;
    cursor: auto;
    white-space: nowrap !important;
}

@media print {

    header,
    footer,
    nav,
    date {
        display: none !important;
    }

    img {
        width: 100% !important;
    }

    .no-display,
    .v-input__control,
    input[type="button"],
    input[type="submit"],
    input[type="reset"],
    #v-card {
        display: none !important;
    }

    .box {
        background-color: white !important;
        /* margin: 8px !important;
    padding: 8px; */
        border: none !important;
        /* overflow: hidden !important; */
    }

    @page {
        size: A4;
        margin-top: none !important;
        padding-top: none;
        /* size: 16in 17in; */
        size: 20in 17in;
    }

    .scroll {
        overflow-x: hidden;
    }

    v-simple-table {
        overflow-x: hidden !important;
    }
}

.trust-logo {
    width: 86%;
}

.schl-logo {
    width: 86%;
}
</style>
